import React, { useMemo, useState } from "react";

// merge-tag helper (avoids writing raw double-brace tokens in source)
const mt = (n) => "{" + "{" + n + "}" + "}";

// wrap the campaign HTML in an isolated document so its styles never leak into
// the app layout; the preview renders inside a contained iframe.
const frameDoc = (h) =>
  '<!doctype html><html><head><meta charset="utf-8"/>' +
  '<meta name="viewport" content="width=device-width, initial-scale=1"/>' +
  '<style>html,body{margin:0;padding:20px;background:#fff;color:#111;' +
  'font-family:Arial,Helvetica,sans-serif;line-height:1.5;}img{max-width:100%;height:auto;}</style>' +
  '</head><body>' + (h || "<p style='color:#8a90a6'>Your email preview will appear here.</p>") + '</body></html>';

export default function ContentStep({ form, updateForm }) {
  const [aiPrompt, setAiPrompt] = useState("");
  const [device, setDevice] = useState("desktop");

  function generateAIContent() {
    const content =
      "<h1>" + (form.subject || "Your Campaign Subject") + "</h1>\n" +
      "<p>Hello " + mt("first_name") + ",</p>\n" +
      "<p>Thank you for being part of our community. This content was generated " +
      "using the AI editor. You can edit every section before sending.</p>\n" +
      "<h2>What's New?</h2>\n" +
      "<p>Add product updates, announcements, offers, newsletters, or any " +
      "marketing content here.</p>\n" +
      '<p><a href="#">Learn More</a></p>\n' +
      "<p>Regards,<br/>" + (form.fromName || "Marketing Team") + "</p>";
    updateForm("html", content.trim());
  }

  function insertVariable(variable) {
    updateForm("html", (form.html || "") + "\n" + mt(variable));
  }

  const previewDoc = useMemo(() => frameDoc(form.html), [form.html]);

  return (
    <div className="sx-content-layout">
      <div className="sx-content-top">
        <div>
          <h2>Email Content</h2>
          <p>Create and edit your campaign content.</p>
        </div>

        <div className="sx-content-actions">
          <span className="sx-content-actions-label">Insert:</span>
          <button type="button" onClick={() => insertVariable("first_name")}>First Name</button>
          <button type="button" onClick={() => insertVariable("email")}>Email</button>
          <button type="button" onClick={() => insertVariable("company")}>Company</button>
        </div>
      </div>

      <div className="sx-content-grid">
        <div className="sx-content-editor">
          {form.editorType === "ai" && (
            <div className="sx-ai-prompt">
              <textarea
                value={aiPrompt}
                onChange={(e) => setAiPrompt(e.target.value)}
                placeholder="Describe the email you want to create..."
              />
              <button type="button" className="sendx-yellow-btn" onClick={generateAIContent}>
                Generate Email
              </button>
            </div>
          )}

          <div className="sx-editor-head">HTML content</div>
          <textarea
            className="sx-content-code"
            spellCheck={false}
            value={form.html || ""}
            onChange={(e) => updateForm("html", e.target.value)}
            placeholder="Write or paste your email HTML here..."
          />
        </div>

        <div className="sx-content-preview">
          <div className="sx-preview-head">
            <span>Live Preview</span>
            <div className="sx-preview-devices">
              <button
                type="button"
                className={device === "desktop" ? "active" : ""}
                onClick={() => setDevice("desktop")}
              >
                Desktop
              </button>
              <button
                type="button"
                className={device === "mobile" ? "active" : ""}
                onClick={() => setDevice("mobile")}
              >
                Mobile
              </button>
            </div>
          </div>
          <div className="sx-preview-stage">
            <iframe
              title="Email preview"
              className={`sx-preview-frame ${device}`}
              sandbox="allow-same-origin"
              srcDoc={previewDoc}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
